import Vue from "vue";
import App from "./App.vue";
import "./plugins/axios";
import "./registerServiceWorker";
import "./scss/styles.scss";
import router from "./router";
import store from "./store";
import Vlf from "vlf";
import localforage from "localforage";

import Container from "./components/Container.vue";
import Navbar from "./components/Navbar.vue";

Vue.config.productionTip = false;
Vue.use(Vlf, localforage);

Vue.filter("capitalize", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.component("navbar", Navbar);
Vue.component("container", Container);

store.subscribe((mutation, state) => {
  // console.log("store updated:", mutation.type);
  localforage.setItem("store", state);
});

localforage.getItem("store").then(cached => {
  if (cached) {
    store.commit("INIT_STORE", cached);
  }
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
});
